import React, { useState } from "react";
import { graphql, useStaticQuery, navigate, Link } from "gatsby";
import TopNav from "./topnav";
import Nav from "./nav";

import Devis24h from "../../assets/icons/devis-sous-24_bleu.svg"
import Maquette from "../../assets/icons/maquette-virtuelle_bleu.svg"
import Livraison7 from "../../assets/icons/livraison_bleu.svg"
import France from "../../assets/icons/impression-francaise_bleu.svg"

import Phone from "../../assets/icons/phone.svg";
import Cross from "../../assets/icons/cross.svg";
import Hero from "../hero/hero";
import SearchForm from "../search-form/search-form";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ObfuscatedLink from "../obfuscated-link";
import IconsLineCat from "../icons-line-cat/icons-line-cat";
const Header = ({ title, description, showBanner: showHero = false, heroImage: bgImage, productAdded }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const [cart, setCart] = useState([]);
  const [email, setEmail] = useState('');
  const [file, setFile] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { logo, image1, image2 } = useStaticQuery(query);
  const [utmParams, setUTMParams] = useState({});
  const { utm_campaign, utm_term, gad_source } = utmParams;

  React.useEffect(() => {
    if (productAdded && openCart === false) {
      toggleModal();
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      productAdded = null;
    }
  }, undefined);

  React.useEffect(() => {
    // Récupérer depuis dataLayer
    if (typeof window !== 'undefined') {
      const storedUTM = window.dataLayer.find(item => item.event === "utm_params_received");
      if (storedUTM) {
        setUTMParams(storedUTM.utm_params);
      }
    }
  }, [setUTMParams]);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  }

  const toggleModal = () => {
    if (openCart === true) {
      setOpenCart(false);
    } else {
      const cartContent = getCartContent();
      if (cartContent.length === 0) return;
      setCart(cartContent);
      setOpenCart(true);
    }
  };

  const getCartContent = () => {
    if (typeof window === 'undefined') {
      return [];
    }
    let cartContent = localStorage.getItem("ttbgCart");
    if (cartContent) {
      return JSON.parse(cartContent);
    }
    return [];
  };

  const cartContentCount = getCartContent().reduce(
    (acc, item) => (acc += +item.quantity),
    0
  );

  const removeItem = (index) => (e) => {
    e.preventDefault();
    if (typeof window === 'undefined') {
      return false;
    }
    if (cart && cart.length > index && index >= 0) {
      cart.splice(index, 1);
      const newCart = [...cart];
      localStorage.setItem("ttbgCart", JSON.stringify(newCart));
      if (newCart.length === 0) setOpenCart(false);
      setCart(newCart);
    }

    return false;
  };

  const purgeCart = () => {
    if (typeof window === 'undefined') {
      return false;
    }
    const newCart = [];
    localStorage.setItem("ttbgCart", JSON.stringify(newCart));
    if (newCart.length === 0) setOpenCart(false);
    setCart(newCart);
  };

  const handleAttachment = e => {
    setFile(e.target.files[0])
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    
    // Empêcher les soumissions multiples
    if (isSubmitting) {
      return;
    }
    
    setIsSubmitting(true);
    const myForm = document.getElementById('devis-form');
    const formData = new FormData(myForm);
    // const postData = encode({
    //   ...formData.reduce((acc, p) => acc[p[0]] = p[1], {}),
    //   file
    // });
    fetch('/', {
      method: 'POST',
      // headers: { "Content-Type": "multipart/form-data" },
      body: formData

    }).then(() => {
      purgeCart();
      navigate("/gracias");
    }
    ).catch((error) => {
      setIsSubmitting(false);
      alert(error);
    })
  }

  const icons = [
    {
      src: <Devis24h height="64" />,
      text: "PRESUPUESTO EN 24H",
      alt: "PRESUPUESTO EN 24H",
    },
    {
      src: <Maquette height="64" />,
      text: <span>MAQUETA<br />VIRTUAL</span>,
      alt: "MAQUETA VIRTUAL",
    },
    {
      src: <Livraison7 height="64" />,
      text: <span>FABRICADO Y ENVIADO<br />EN 10 DÍAS LABORABLES</span>,
      alt: "FABRICADO Y ENVIADO EN 10 DÍAS LABORABLES",
    },
    {
      src: <France height="64" />,
      text: "IMPRESIÓN FRANCESA",
      alt: "IMPRESIÓN FRANCESA",
    },
  ];


  return (
    <>
      <div className="top-0 sticky w-full z-50 bg-white shadow" style={{ position: 'sticky' }}>
        <TopNav />

        <header className="container relative px-4 py-2 lg:py-4" role="banner">
          <div className="flex justify-between items-center lg:items-end">
            <a href="#" onClick={toggleMenu} className="block lg:hidden">
              <svg fill="#123b84" viewBox="0 0 100 80" width="40" height="40">
                <rect width="100" height="15"></rect>
                <rect y="30" width="100" height="15"></rect>
                <rect y="60" width="100" height="15"></rect>
              </svg></a>
            <Link
              to="/"
              title="El taller del tote bag - Impresión de tote bags personalizados"
              rel="home"
              className="block"
            >
              <GatsbyImage
                image={getImage(logo)}
                alt="Logo del taller del tote bag"
                // className="w-32 md:w-40 lg:w-auto"
                // imgStyle={{ maxWidth: '100%', height: 'auto' }}
              />
            </Link>

            <div className="md:flex-grow md:ml-4">
              <div className="flex items-center justify-between lg:mb-5">
                <SearchForm />
                <div className="hidden lg:block">
                  <ObfuscatedLink to="tel:+34851960400">
                    <Phone className="inline-block relative -top-1" />{" "}
                    <span className="text-1.5xl font-semibold hover:text-blue">
                      +34 851 960 400
                    </span>
                  </ObfuscatedLink>
                </div>
                {cartContentCount > 0 && (
                  <div
                    onClick={toggleModal}
                    className="flex items-center text-blue cursor-pointer"
                  >
                    <span className="hidden lg:block uppercase text-sm mr-3">Su presupuesto</span>
                    <div className="relative">
                      <span className="cart-icon-handle" />
                      <div className=" flex justify-center items-center w-9 h-8 border-2 border-blue font-semibold text-sm">
                        {cartContentCount}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Nav showMenu={showMenu} closeMenu={() => setShowMenu(false)} />
            </div>
          </div>
        </header>
      </div>

      <div>
        {(showHero || bgImage) && <Hero description={description} title={title} bgImage={bgImage} />}

        <div className={openCart ? 'flex justify-center' : 'hidden'}>
          <div className="cart-backdrop" onClick={() => setOpenCart(false)} />
          <div className="cart-modal w-full md:w-10/12 p-6 z-30 shadow rounded-2xl">
            <div className="flex flex-wrap mb-16 h-full">
              <div className="md:w-6/12 z-30 flex-col pt-4">
                <div className="uppercase text-gray-600 text-xl font-semibold mb-4">
                  Mis productos
                </div>
                {cart &&
                  cart.map((cartItem, index) => (
                    <div className="z-30" key={index}>
                      <div className="flex mb-10">
                        <div>
                          {(() => {
                            // Produit ou variation parfois sans image (ex. import sans visuel)
                            const cartImage =
                              getImage(cartItem.variation?.Image?.localFile) ||
                              getImage(cartItem.product?.image?.localFile);
                            return cartImage ? (
                              <GatsbyImage
                                image={cartImage}
                                style={{ marginBottom: 8, width: '120px' }}
                                alt={cartItem.product?.title || 'producto'}
                              />
                            ) : (
                              <div className="bg-gray-100 rounded-md" style={{ marginBottom: 8, width: '120px', height: '120px' }} />
                            );
                          })()}

                        </div>
                        <div className="w-full px-6 text-sm">
                          <div className="flex justify-between items-start mb-2">
                            <span className="uppercase text-gray-500 font-semibold mb-2 mr-2">
                              {cartItem.product?.title}
                            </span>

                            <button
                              type="button"
                              onClick={removeItem(index)}
                              className="bg-transparent border-none text-sm mt-1"
                            >
                              <Cross width={12} height={12} />
                            </button>
                          </div>
                          <span className="block mb-1">
                            Cantidad: {cartItem.quantity}
                          </span>
                          <span className="capitalize flex items-center mb-1">
                            <span>
                              Color: {cartItem.color?.Nom?.replace("-", " ")}
                            </span>
                            <span
                              className="ml-2 p-3 rounded-md inline-block"
                              style={{ backgroundColor: cartItem.color?.valeur }}
                            />
                          </span>
                          <span className="block mb-1">Marcado: {cartItem.marquage}</span>
                          <span className="block mb-1">Cara(s): {cartItem.faces}</span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <form
                id="devis-form"
                className="w-full md:w-6/12 flex-col p-4 bg-blue-lighter"
                onSubmit={handleSubmit}
                name="demander-devis"
                data-netlify="true"
                netlify-honeypot="potdemiel"
              >
                <input type="hidden" name="form-name" value="demander-devis" />
                <input type="hidden" name="gad_source" value={gad_source || "0"} />
                <input type="hidden" name="utm_campaign" value={utm_campaign || ""} />
                <input type="hidden" name="utm_term" value={utm_term || ""} />
                <input type="hidden" id="subject" name="subject" value={`Solicitud de presupuesto de ${email}`}></input>
                <p className="hidden">
                  <label>No rellene este campo si es humano: <input name="potdemiel" /></label>
                </p>
                <div className="flex justify-between items-center">
                  <p className="text-xl font-semibold text-blue">
                    Obtener un presupuesto
                  </p>
                  <div className="cursor-pointer" onClick={() => setOpenCart(false)}>
                    <Cross width={12} height={12} />
                  </div>
                </div>
                <label
                  htmlFor="logo-import"
                  className="block text-gray-600 mb-1 text-sm font-semibold"
                >
                  Elegir el archivo cara A
                </label>
                <input
                  name="file"
                  type="file"
                  id="logo-import"
                  className="block border-none bg-transparent shadow-none p-0 text-sm"
                />
                <label
                  htmlFor="logo-import"
                  className="block text-gray-600 mb-1 text-sm font-semibold"
                >
                  Elegir el archivo cara B (si impresión en 2 caras)
                </label>
                <input
                  name="fileB"
                  type="file"
                  id="logo-importB"
                  className="block border-none bg-transparent shadow-none p-0 text-sm"
                />
                <div className="my-2">
                  <label className="block mb-2 text-gray-500 text-sm font-semibold">
                    Su mensaje
                  </label>
                  <textarea name="message" className="block mb-8 p-2 w-full border-1 border-gray-400" />
                </div>
                <span className="text-gray-700 text-xl font-semibold ">
                  Mis datos de contacto
                </span>
                <div className="my-2">
                  <label className="text-gray-700 text-sm font-semibold">
                    Su nombre (obligatorio){" "}
                    <span className="text-red-danger">*</span>
                  </label>
                  <input name="Nom" type="text" className="mb-0" />
                </div>
                <div className="my-2">
                  <label className="text-gray-700 text-sm font-semibold">
                    Su dirección de correo (obligatorio){" "}
                    <span className="text-red-danger">*</span>
                  </label>
                  <input
                    required
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    className="mb-0"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    title="Por favor, introduce una dirección de correo electrónico válida"
                  />
                </div>
                <div className="my-2">
                  <label className="text-gray-700 text-sm font-semibold">
                    Su número de teléfono
                  </label>
                  <input name="tel" type="text" className="mb-8" />
                </div>
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <div key={i}>
                    <input
                      type="hidden"
                      name={`produit_${i + 1}`}
                      value={cart && cart[i] ? `${cart[i].product?.title} | ${cart[i].quantity} uds | ${cart[i].color?.Nom} | ${cart[i].marquage} | ${cart[i].faces} cara(s)` : 'sin producto añadido'} />
                  </div>
                ))}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="block w-full  text-sm bg-blue text-white py-2 uppercase disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Envío en curso...' : 'Enviar mi presupuesto'}
                </button>
                <div
                  className="uppercase cursor-pointer text-sm hover:underline text-center mt-6"
                  onClick={() => setOpenCart(false)}
                >
                  Continuar mis compras
                </div>

                <div className="mt-12">
                  <IconsLineCat iconsToSet={icons} />
                </div>
                {/* <div className="flex justify-evenly mb-8 mt-12">
                  <div className="flex flex-wrap md:space-x-4 items-center justify-center">
                    <Devis24h height="64" />
                    <span className="">Votre devis en 24h</span>
                  </div>
                  <div className="flex flex-wrap md:space-x-4 items-center justify-center">
                    <Livraison7 height="64" />
                    <span className="">Livraison 7j</span>
                  </div>
                  <div className="flex flex-wrap md:space-x-4 items-center justify-center">
                    <LivraisonOfferte height="64" />
                    <span className="">Livraison gratuite</span>
                  </div>
                </div> */}
              </form>
            </div>

          </div>
        </div>
      </div>

      <div className="hidden md:grid-cols-1 md:grid-cols-2 md:grid-cols-3 md:grid-cols-4 md:grid-cols-5 md:grid-cols-6 md:grid-cols-7 md:grid-cols-8"></div>
    </>
  );
};

const query = graphql`
  query {
    logo: file(
      relativePath: { eq: "LOGO-TALLER-DEL-TOTE-BAG.webp" }
      sourceInstanceName: { eq: "logos" }
    ) {
      childImageSharp {
        gatsbyImageData(
          height: 100
          backgroundColor: "white",
          quality: 100,
          layout: CONSTRAINED
        ) 
      }
    }
    image1: file( relativePath: { eq: "devien-en-24h-latelier-du-tote-bag-1.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 80
          height: 80
        ) 
      }
    }
    image2: file(
      relativePath: {
        eq: "livraison-express-latelier-du-tote-bag.png"
      }
      sourceInstanceName: { eq: "uploads" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 80, height: 80) 
      }
    }
  }
`;

export default Header;
